/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from '@mui/material/MenuItem';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import { APP_STATE } from 'services/Define';

function ImportText({ callback, setButtonGroup }) {
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [modalAdd, setModalAdd] = useState(false);
  const [text, setText] = useState('');
  const txtText = useRef(null);

  const add = () => {
    setModalAdd(false);
    callback(text);
  };

  const renderAdd = () => {
    return (
      <Dialog
        open={modalAdd}
        maxWidth='lg'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => setModalAdd(false)}
      >
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox>
            <MDInput
              label='วางข้อมูลจาก Excel / Google sheet'
              onChange={(e) => setText(e.target.value)}
              value={text}
              variant='standard'
              fullWidth
              multiline
              rows={20}
              InputProps={{
                inputRef: txtText,
                inputProps: {
                  autoComplete: 'off',
                  placeholder:
                    'รหัสซื้อขาย | จำนวน | แถม | ราคาต่อหน่วย | ส่วนลดต่อหน่วย | น้ำหนักต่อหน่วย | เลขล็อต | เลขกำกับ | วัตถุดิบ/ผลผลิต',
                },
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant='gradient' color='info' onClick={add}>
            <Icon>add</Icon>&nbsp;{t(`element.add`)}
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, [id]);

  return (
    <>
      <MenuItem
        onClick={() => {
          setButtonGroup(null);
          setText('');
          setModalAdd(true);

          setTimeout(function () {
            txtText.current.focus();
          }, 500);
        }}
      >
        <MDTypography variant='body2'>
          <Icon color='secondary'>description</Icon>&nbsp;ข้อความ
        </MDTypography>
      </MenuItem>

      {renderAdd()}
    </>
  );
}

ImportText.propTypes = {
  callback: PropTypes.func.isRequired,
  setButtonGroup: PropTypes.func.isRequired,
};

export default ImportText;
